import React, { Component, Fragment } from 'react';
import { documentTitle } from '../../utils';
import InterPageLinkUp from '../InterPageLinkUp/InterPageLinkUp';

class PUtmeScore extends Component {
  constructor(props) {
    super(props);

    this.title = 'Post-U.T.M.E Score';
  }

  componentDidMount() {
    document.title = `${documentTitle}${this.title}`;
    scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <h2 className="main-text">{ this.title }</h2>
        <main className="w-700 txt-al-c">
          <p className="sub-text w-100 p-10 m-b-20 bc-c1 bd-r-20 bx-sh-fx ttn-3 break-word">Check your post-U.T.M.E score here: <a href="https://putmeresult.unilag.edu.ng/" target="_blank" rel="noopener noreferrer" className="text-link">https://putmeresult.unilag.edu.ng/</a></p>
          <InterPageLinkUp link="calculate-aggregate-score" />
        </main>
      </Fragment>
    );
  }
}

export default PUtmeScore;
